import { newGuid } from "@/assets/utils/guid";
import { PolicyConfiguration } from "../policy-configurations";
import { SeatingStrategyBase } from "../seating-strategies";
import { VenueSection } from "./venue-section";

export class VenueSetup {
  constructor(id, name, venueDetailsId) {
    this.id = id ? id : newGuid();
    this.venueSetupId = { id: this.id};
    this.name = name;
    this.venueDetailsId = venueDetailsId;
    this.venueSections = [];
    this.isActive = false;
    this.created = undefined;
    this.deleted = undefined;
    this.venuePolicies = [];
    this.seatingStrategies = [];
    this.bookingOnRequestOnly = false;
    this.type = undefined;
    this.floorplan = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let setup =  Object.assign(new VenueSetup(), json);
    if(setup.venuePolicies) {
      setup.venuePolicies = setup.venuePolicies.map(m => {
        return PolicyConfiguration.fromJSON(m);
      });
    }

    if(setup.seatingStrategies) {
      setup.seatingStrategies = setup.seatingStrategies.map(m => {
        return SeatingStrategyBase.fromJSON(m);
      });
    }

    if(setup.venueSections){
      setup.venueSections = setup.venueSections.map(m => {
        return VenueSection.fromJSON(m);
      });
    }
    return setup;
  }
}

